import Permissoes from "@/utils/permissoes";

const routes = [
  {
    path: "/operacao/dashboard",
    name: "dashboard-operacao",
    component: () => import("@/views/operacao/dashboard/index.vue"),
    meta: {
      title: "Operação",
      authRequired: true,
      permissoes: [Permissoes.OperacaoDashboard],
      menus: [Permissoes.Operacao, Permissoes.OperacaoDashboard]
    },
  },

  {
    path: "/operacao/registrar-ops",
    name: "operacao-registrar-ops",
    component: () => import("@/views/operacao/registrar-ops/index.vue"),
    meta: {
      title: "Registrar operações",
      authRequired: true,
      permissoes: [Permissoes.OperacaoRegistarOp],
      menus: [Permissoes.Operacao, Permissoes.OperacaoRegistarOp]
    },
  },

  {
    path: "/operacao/ver-roteiro/:id/:viagemId",
    name: "operacao-ver-roteiro",
    component: () => import("@/views/operacao/dashboard/form.vue"),
    meta: {
      title: "Operação",
      authRequired: true,
      permissoes: [Permissoes.OperacaoDashboard],
      menus: [Permissoes.Operacao, Permissoes.OperacaoDashboard]
    },
  },
  {
    path: "/operacao/dashboard/editar-roteiro-item/:rotaProgramacaoId",
    name: "operacao-dashboard-editar-roteiro-item",
    component: () => import("@/views/operacao/editar-item/form.vue"),
    meta: {
      title: "Editar",
      authRequired: true,
      permissoes: [Permissoes.OperacaoDashboard, Permissoes.OperacaoEditarOps],
      menus: [Permissoes.Operacao, Permissoes.OperacaoDashboard]
    },
  },
  {
    path: "/operacao/registrar-ops/editar-roteiro-item/:rotaProgramacaoId",
    name: "operacao-registrar-ops-editar-roteiro-item",
    component: () => import("@/views/operacao/editar-item/form.vue"),
    meta: {
      title: "Editar",
      authRequired: true,
      permissoes: [Permissoes.OperacaoDashboard, Permissoes.OperacaoEditarOps],
      menus: [Permissoes.Operacao, Permissoes.OperacaoRegistarOp]
    },
  },

  {
    path: "/operacao/fila-integracao",
    name: "operacao-fila-integracao",
    component: () => import("@/views/operacao/fila-integracao/index.vue"),
    meta: {
      title: "Fila de Integração",
      authRequired: true,
      permissoes: [Permissoes.OperacaoFilaIntegracao],
      menus: [Permissoes.Operacao, Permissoes.OperacaoFilaIntegracao]
    },
  },
];
export default routes;
